function validate(token, ref) {
	return token === getToken(ref);
}

function getToken(ref) {
	return btoa(ref);
}

export default { validate }


// WEBPACK FOOTER //
// ./src/domain/token-parser.js